import React from 'react'
import HeroImage1 from '../images/hero-images/pay-banner-1.jpeg'
import HeroImage2 from '../images/hero-images/pay-banner-2.jpeg'
import HeroImage3 from '../images/hero-images/pay-banner-3.jpeg'
import HeroImage4 from '../images/hero-images/pay-banner-4.jpeg'

const slides = [
    {
        id: 1,
        image: HeroImage1,
        mainText: 'Digitalotal Payments Are Projected<br /> To Reach 14.78 Trillian by 2027 <br />Let Your Customers The Convenience Pay Online<br /> <span>Pay By PragICTS</span>',
        subText: ''
    },
    {
        id: 2,
        image: HeroImage2,
        mainText: 'Cashless Transaction Needs to Lead<br />the Way For Digital Payment Trends<br />Let Your Customers The Convenience Pay Online<br /> <span>Pay By PragICTS</span>',
        
        action: {
            'link': '/'
        }
    },
    {
        id: 3,
        image: HeroImage3,
        mainText: 'Let Your Customers Pay At Their Convenience<br />Any Time - Place - Device<br /> <span>Pay By PragICTS</span>',
       
    },
    {
        id: 4,
        image: HeroImage4,
        mainText: 'Fully Secure<br />Muti Layered/Abstracted and 2048 Bit, Sha-2 SSL Encrypted<br /> <span>Pay By PragICTS</span>',
        
    }
]

const HeroSlides = () => {

    return (
        <div className="hero-wrap" id="sec1" data-scrollax-parent="true">
            <div className="slider-carousel-wrap full-height fullscreen-slider-wrap">
                <div className="fullscreen-slider full-height cur_carousel-slider-container fl-wrap" data-slick='{"autoplay": true, "autoplaySpeed": 4000 , "pauseOnHover": false}'>
                {slides.map(slide => (
                    <div key={slide.image} className="fullscreen-slider-item full-height fl-wrap">
                        <div className="bg par-elem hero-bg"  data-bg={slide.image}></div>
                        <div className="overlay"></div>
                        <div className="half-hero-wrap">
                            <h1 dangerouslySetInnerHTML={{ __html: slide.mainText }}></h1>
                           
                            <div className="clearfix"></div>
                            {/* <a href={slide.action.link} className="custom-scroll-link btn float-btn flat-btn color-btn mar-top">Let's Start</a> */}
                        </div>
                    </div>
                ))}
                </div>
                <div className="sp-cont   sp-cont-prev"><i className="fal fa-arrow-left"></i></div>
                <div className="sp-cont   sp-cont-next"><i className="fal fa-arrow-right"></i></div>
                <div className="fullscreenslider-counter"></div>
            </div>
            <div className="hero-decor-numb">
                <span>6.9149106  </span><span>79.9105932 </span>
                <a href="https://g.page/PragICTS?share" target="_blank" className="hero-decor-numb-tooltip">Based In Colombo, Sri Lanka</a>
            </div>
        </div>
    )
}

export default HeroSlides
